exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/degree-home.js-WebpackMultiOutput";